<template>
  <div>
    <div class="table-responsive employee-table-wrapper pb-0">

        <div class="ibox-title dashboard_title company-form-box-title pl-0 mb-3">
            <h4 class="clearfix">
                <span class="float-left">Swap Request List</span>
                <span class="float-right"><b-button @click="$bvModal.show('bv-modal-swap-request-create')">Create Swap Request</b-button></span>
            </h4>
        </div>
          
      <table class="employee-list-table table table-hover dataTable table-overflow">
        <thead class="table-head">
        <tr class="table-head">
          <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey == column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" class="cursor-pointer"><span>{{column.label}}</span></th>
          <th class="text-right">Actions</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="swap in paginatedData" :key="swap.id" class="hover-bg table-row border-bottom mx-2">
            <td v-b-tooltip.hover.top="(swap.from_shift ? swap.from_shift.start_time + '-' + swap.from_shift.end_time : '')">
                {{ swap.from_shift ? swap.from_shift.name + ' ' + swap.from_shift.code : '—' }}
            </td>
            <td>{{ swap.from_date }}</td>
            <td>{{ swap.to_employee_name }}</td>
            <td v-b-tooltip.hover.top="(swap.to_shift ? swap.to_shift.start_time + '-' + swap.to_shift.end_time : '')">
                {{ swap.to_shift ? swap.to_shift.name + ' ' + swap.to_shift.code : '—' }}
            </td>
            <td>{{ swap.to_date }}</td>
            <td class="reason-text">
                {{ swap.reason }}
            </td>
            <td >
                {{ swap.updated_by }}
            </td>

            <td class="text-center">
                <span class="leave-status" v-if="swap.status == 1"><i class="far fa-dot-circle mr-1 text-success"></i>Approved</span>
                <span class="leave-status" v-else-if="swap.status == 0"><i class="far fa-dot-circle mr-1 text-primary"></i>Applied</span>
                <span class="leave-status" v-else-if="swap.status == 2"><i class="far fa-dot-circle mr-1 text-danger"></i>Declined</span>
            </td>
            <td class="text-right">
                <div v-if="swap.status == 0" class="action">
                    <b-button-toolbar class="float-right position-relative">
                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                        href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <b-icon icon="three-dots-vertical"></b-icon>
                    </a>
                    <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                        <b-button-group>
                        <b-button class="border-0 rounded py-0" variant="outline-secondary" title="Delete Swap Request" @click="deleteSwap(swap.id)">
                            <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                        </b-button>
                        </b-button-group>
                    </div>
                    </b-button-toolbar>
                </div>
            </td>
        </tr>
        </tbody>

      </table>

      <div v-if="paginatedData.length == 0" class="px-3 py-3 list-no-data">No Result Found!</div>
      <div v-else class="p-3">
        <ul class="pagination b-pagination float-left mb-0 mt-1">
          <li class="page-item disabled m-2">View</li>
          <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
          <li class="page-item disabled m-2">per page. Total {{swapData.length}} records found.</li>
        </ul>
        <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>

      </div>
    </div>

    <b-modal id="bv-modal-swap-request-create" title="Add Swap Request" hide-footer @hidden="resetForm" size="xl" scrollable>
        <b-card>
          <b-form>
            <b-row>

              <b-col cols="6">
                <b-form-group id="start-group" label-for="start" class="required-field mb-0">
                  <template #label>
                    Start Date <b-icon icon="info-circle" variant="info" v-b-tooltip.hover.top="'Pick the start date to load all shifts the employee has from this date onward.'"></b-icon>
                  </template>
                  <b-input-group class="mb-0">
                    <b-form-input @input="setToDateAndLoadShift" id="start" name="start" v-model="fdata.start" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                                  autocomplete="off" :state="validateState('start')" aria-describedby="start-feedback" data-vv-as="Start Date"/>
                    <b-input-group-append class="mb-0">
                      <b-form-datepicker @input="setToDateAndLoadShift" class="mb-0" id="day_one" button-only right locale="en-US" v-model="fdata.start" />
                    </b-input-group-append>
                    <b-form-invalid-feedback id="start-feedback">
                      {{ veeErrors.first('start') }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group id="end-group" label-for="end" class="required-field">
                  <template #label>
                    End Date <b-icon icon="info-circle" variant="info" v-b-tooltip.hover.top="'Pick the end date to load all shifts the employee has up to this date.'"></b-icon>
                  </template>
                  <b-input-group class="mb-0">
                    <b-form-input id="end" name="end" @input="loadEmployeeShifts" v-model="fdata.end" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                                  autocomplete="off" :state="validateState('end')" aria-describedby="end-feedback" data-vv-as="End Date"/>
                    <b-input-group-append class="mb-0">
                      <b-form-datepicker :min="fdata.start" @input="loadEmployeeShifts" class="mb-0" id="day_two" button-only right locale="en-US" v-model="fdata.end" />
                    </b-input-group-append>
                    <b-form-invalid-feedback id="end-feedback">{{ veeErrors.first('end') }}</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>


              <b-col cols="12" md="12">
                <b-form-group label="Select Shift" label-for="shift_id" class="required-field">
                  <b-form-select id="shift_id" name="shift_id" v-model="fdata.shift_id" :options="employeeShifts" v-validate="{required: true}"
                                 :state="validateState('shift_id')" aria-describedby="shift_id-feedback" data-vv-as="Shift"/>
                  <b-form-invalid-feedback id="shift_id-feedback">{{ veeErrors.first('shift_id') }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group id="target_date-group" label-for="target_date" class="required-field mb-0">
                  <template #label>
                    Swap Desired Date <b-icon icon="info-circle" variant="info" v-b-tooltip.hover.top="'The date the employee wants to exchange their shift for.'"></b-icon>
                  </template>
                  <b-input-group class="mb-0">
                    <b-form-input @input="fdata.end = fdata.target_date;" id="target_date" name="target_date" v-model="fdata.target_date"
                                  v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                  :state="validateState('target_date')" aria-describedby="target_date-feedback" data-vv-as="Period Start Date"/>
                    <b-input-group-append class="mb-0">
                      <b-form-datepicker class="mb-0" id="day_three" :min="minDate" button-only right locale="en-US" v-model="fdata.target_date" />
                    </b-input-group-append>
                    <b-form-invalid-feedback id="target_date-feedback">{{ veeErrors.first('target_date') }}</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="6" md="6">
                <b-form-group label-for="to-shift" class="required-field">
                  <template #label>
                    Desired Shift <b-icon icon="info-circle" variant="info" v-b-tooltip.hover.top="'Select the shift the employee wants to work on the selected date.'"></b-icon>
                  </template>
                  <b-form-select id="to-shift" name="to_shift_id" v-model="fdata.target_shift" :options="shiftOptions" @change="loadTo()"
                                 v-validate="'required'" :state="validateState('to_shift_id')" aria-describedby="to_shift_id-feedback" data-vv-as="To Shift">
                    <template #first>
                      <b-form-select-option :value="null" disabled>Select Shift</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="to_shift_id-feedback">{{ veeErrors.first('to_shift_id') || ' ' }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="12">
                <b-form-group label-for="to-emp">
                  <template #label>
                    Swap With Employee <b-icon icon="info-circle" variant="info" v-b-tooltip.hover.top="'Choose the employee who will exchange shifts on the desired date.'"></b-icon>
                  </template>
                  <b-form-select id="to-emp" name="to_employee_id" v-model="fdata.to_employee_id" :options="toEmployeeOptions" v-validate=""
                                 :state="validateState('to_employee_id')" aria-describedby="to_employee_id-feedback" data-vv-as="Employee">
                    <template #first>
                      <b-form-select-option :value="null">Select employee</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="to_employee_id-feedback">{{ veeErrors.first('to_employee_id') }}</b-form-invalid-feedback>

                  <small v-if="toAssignment.shift" class="text-muted d-block mt-1">
                    Current: {{ toAssignment.shift.name }}
                    ({{ toAssignment.shift.start_time }}–{{ toAssignment.shift.end_time }})
                  </small>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group label="Reason (optional)" label-for="reason">
              <b-form-textarea id="reason" name="reason" v-model="fdata.reason" v-validate="'max:255'" :state="validateState('reason')" aria-describedby="reason-feedback" maxlength="255" placeholder="Short reason"/>
              <b-form-invalid-feedback id="reason-feedback">{{ veeErrors.first('reason') }}</b-form-invalid-feedback>
            </b-form-group>

            <b-button type="button" @click="submit" variant="primary">Submit Swap Request</b-button>
            <b-button @click="resetForm" type="button">Reset</b-button>
            <b-button variant="primary" @click="backSwap" type="button">Back</b-button>
          </b-form>
        </b-card>
      </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  props: ['status'],
  data() {
    let sortOrders = {};
    let columns = [
      { label: 'From Shift', name: 'from_shift' },
      { label: 'From Shift Date', name: 'from_date' },
      { label: 'To Employee', name: 'to_name' },
      { label: 'To Shift', name: 'to_shift' },
      { label: 'To Shift Date', name: 'to_date' },
      { label: 'Reason', name: 'reason' },
      { label: 'Updated By', name: 'updated_by' },
      { label: 'Status', name: 'status' },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    return {
      swapData: [],
      search: '',
      page: 1,
      columns: columns,
      sortOrders: sortOrders,
      sortKey: 'from_shift',
      perPage: 10,
      totalRows: 0,
      totalPages: null,
      loading: false,
      selectedShift: null,
      fromEmployeeOptions: [],
      toEmployeeOptions: [],
      employees: [],
      shifts: [],
      shiftOptions: [],
      employeeShifts: [],
      fdata: {
        date: '',
        shift_id: null,
        to_employee_id: null,
        reason: '',
        start: '',
        end: '',
        target_date: '',
        target_shift: null,
      },
      fromAssignment: {},
      toAssignment: {},
      pagination: { currentPage: 1, pages: 1 },
      length_options: [
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
        { value: 500, text: '500' },
        { value: 1500, text: '1500' },
      ],
      temp_length: 100,
    };
  },
  methods: {
    deleteSwap(id) {
        this.$bvModal.msgBoxConfirm('Delete this swap request?', {
            title: 'Confirm',
            okVariant: 'primary',
            okTitle: 'Delete',
            centered: true,
        }).then((confirmed) => {
            if (!confirmed) return;
            axios.post('/front/leave-attendance/swaps/' + id + '/delete')
            .then(() => {
                this.$bvToast.toast('Deleted.', { variant: 'success', solid: true, title: 'Success' });
                this.loadData();
            })
            .catch((e) => {
                this.serverError(e);
            });
        });
    },
    loadData() {
      this.loading = true;
      axios
        .get('/front/leave-attendance/swaps')
        .then((response) => {
          this.swapData = response.data;          // FIX #1: populate swapData, not prop
          this.loading = false;
        })
        .catch((e) => {
          this.serverError(e);
          this.loading = false;
        });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    backSwap() {
      this.$bvModal.hide('bv-modal-swap-request-create');
    },
    resetForm() {
      this.fdata = {
        date: '',
        shift_id: null,
        to_employee_id: null,
        reason: '',
        start: '',
        end: '',
        target_date: '',
        target_shift: null,
      };
      this.employeeShifts = [];
      this.toEmployeeOptions = [];
      this.$validator.reset();
    },
    setToDateAndLoadShift() {
      this.fdata.end = this.fdata.start;
      this.loadEmployeeShifts();
    },
    loadEmployeeShifts() {
      let params = { };

      const ymdPattern = /^\d{4}-\d{2}-\d{2}$/;
      let start = new Date(this.fdata.start);
      if (!ymdPattern.test(this.fdata.start) || isNaN(start.getTime())) {
        return;
      }
      params['start'] = this.fdata.start;

      let end = new Date(this.fdata.end);
      if (!ymdPattern.test(this.fdata.end) || isNaN(end.getTime())) {
        return;
      }
      params['end'] = this.fdata.end;

      axios
        .get(this.$api_url + '/front/leave-attendance/employee/assignments', {
          params: params,
        })
        .then((response) => {
          this.employeeShifts = response.data;
        });
    },
    loadShifts() {
      axios.get('/front/leave-attendance/shifts').then((response) => {
        this.shifts = response.data;
        this.shiftOptions = this.shifts.map((el) => ({
          text: `${el.name} -- (${moment(el.start_time, 'HH:mm:ss').format('hh:mm A')} - ${moment(el.end_time, 'HH:mm:ss').format('hh:mm A')})`,
          value: el.value,
        }));
      });
    },
    loadTo() {
      let formData = new FormData();
      formData.append('target_date', this.fdata.target_date);
      formData.append('target_shift', this.fdata.target_shift);

      axios
        .post('/front/leave-attendance/employees/range', formData)
        .then((response) => {
          this.toEmployeeOptions = response.data;
        })
        .catch((error) => {
          this.serverError(error);
        });
    },
    submit() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        const payload = {
          assignment_id: this.fdata.shift_id,
          to_date: this.fdata.target_date,
          to_employee_id: this.fdata.to_employee_id,
          to_shift_id: this.fdata.target_shift,
          reason: this.fdata.reason,
        };
        axios
          .post('/front/leave-attendance/swaps/create', payload, {
            headers: { 'Content-Type': 'application/json' },
          })
          .then((response) => {
            this.loadData();
            this.$bvToast.toast('Swap created.', {
              variant: 'success',
              solid: true,
              title: 'Success',
            });
            this.$bvModal.hide('bv-modal-swap-request-create');
          })
          .catch((e) => {
            this.serverError(e);
          });
      });
    },

    // FIX #5: add missing utility methods (move to a mixin if you already have one)
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    paginate(list, length, page) {
      this.pagination.pages = Math.ceil(list.length / length) || 1;
      const start = (page - 1) * length;
      return list.slice(start, start + length);
    },
    getIndex(array, key, value) {
      return array.findIndex((item) => item[key] === value);
    },
    setFirstPage() {
      this.pagination.currentPage = 1;
    },
    serverError(e) {
      const msg =
        e.response && e.response.data && e.response.data.message
          ? e.response.data.message
          : 'Something went wrong!';
      this.$bvToast.toast(msg, {
        variant: 'danger',
        solid: true,
        title: 'Error',
      });
    },
  },
  mounted() {
    this.loadShifts();
    this.loadData();
  },
  computed: {
    // FIX #7: provide minDate
    minDate() {
      const d = new Date();
      return d.toISOString().slice(0, 10);
    },
    filteredData() {
      let filtered_list = this.swapData;
      if (this.search) {
        filtered_list = filtered_list.filter((row) => {
          return Object.keys(row).some((key) => {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) > -1
            );
          });
        });
      }
      let sortKey = this.sortKey;
      let order = this.sortOrders[sortKey] || 1;
      if (sortKey) {
        filtered_list = filtered_list.slice().sort((a, b) => {
          let index = this.getIndex(this.columns, 'name', sortKey);
          a = String(a[sortKey]).toLowerCase();
          b = String(b[sortKey]).toLowerCase();
          if (this.columns[index] && this.columns[index].type === 'date') {
            return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
          } else if (this.columns[index] && this.columns[index].type === 'number') {
            return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
          } else {
            return (a === b ? 0 : a > b ? 1 : -1) * order;
          }
        });
      }
      return filtered_list;
    },
    paginatedData() {
      return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
    },
    // FIX #6: removed unused `working` computed that depended on non-existent _netMinutes
  },
};
</script>